import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { ILinkProps, Link } from '@fluentui/react/lib/Link';
import { observer } from 'mobx-react-lite';
import type LinkPreview from 'owa-service/lib/contract/LinkPreview';
import { AssetImage } from 'owa-timestream-asset-sdk';

/** Renders a LinkPreview, with an arbitrary child between the hero image and the title. */
export default observer(function LinkPreviewView({
    linkPreview,
    titleProps,
    children,
}: {
    linkPreview: LinkPreview;
    titleProps: ILinkProps;
    children: React.ReactNode;
}) {
    // NOTE: there are several types derived from LinkPreview, differentiated by the __type field.
    // For example, BingVideoLinkPreview:#Exchange contains MotionThumbnailUrl and EmbeddedHtml
    // which could be used to provide the embedded video if the user hovers or clicks on the image.
    const { Url, Title, Description, ImageUrl } = linkPreview;

    return (
        <div className={styles.linkView}>
            <div className={styles.image}>
                {ImageUrl && <AssetImage src={ImageUrl} role={'presentation'} />}
            </div>
            {children}
            {Title && (
                <Link
                    className={styles.title}
                    href={Url}
                    target="_blank"
                    draggable={false}
                    title={Url}
                    {...titleProps}>
                    {Title}
                </Link>
            )}
            {Description && (
                <div
                    className={classNames(styles.description, {
                        [styles.shortDescription]: !ImageUrl,
                    })}
                    title={Description}>
                    {Description}
                </div>
            )}
        </div>
    );
});
